import { render, staticRenderFns } from "./assess-employee.vue?vue&type=template&id=4768f2a8"
import script from "./assess-employee.vue?vue&type=script&lang=js"
export * from "./assess-employee.vue?vue&type=script&lang=js"
import style0 from "./assess-employee.vue?vue&type=style&index=0&id=4768f2a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports